import React from 'react';
import SignupComponent from '../../components/signupComponent/SignupComponent';




function SignUp() {
    return (
        <div className="signup_container">
          <SignupComponent />
            
        </div>
    )
}

export default SignUp